import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { Text, Text1 } from 'app/shared/ui';

import { color, zIndex } from 'app/shared/styles_js/variables';

export const ModalSt = styled(Flex).attrs(() => ({
  width: 'calc(100% - 24px)',
  bg: 'white',
  flexDirection: 'column',
  alignItems: 'center',
}))`
  position: fixed;
  z-index: ${zIndex.slideIn};
  right: 0;
  left: 0;
  bottom: 75px;
  height: 300px;
  margin: auto;
  padding: 12px;
  border-radius: 4px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  transform: ${({ mode }) => {
    switch (mode) {
      case 'slideIn':
        return 'translateY(0)';
      case 'slideInPDP':
        return 'translateY(-40px)';
      case 'bouncePDP':
        return 'translateY(-80px)';
      case 'slideOut':
        return 'translateY(400px)';
      default:
        return 'translateY(400px)';
    }
  }};
  transition: transform 0.4s ease-in-out;
`;

export const ImageSt = styled.div`
  margin-left: 24px;
  margin-right: 24px;
`;

export const BannerHeadingSt = styled(Text1).attrs(() => ({
  fontWeight: 'bold',
  marginTop: 8,
  marginBottom: 0,
  lineHeight: 2,
  fontSize: 16,
  textAlign: 'center',
  color: color.brandSecondary,
}))``;

export const BannerTextSt = styled(Text).attrs(() => ({
  lineHeight: 1.45,
  marginTop: 8,
  textAlign: 'center',
  marginBottom: 0,
  fontSize: 12,
  as: 'p',
}))``;

export const BannerActionsSt = styled(Flex).attrs(() => ({
  width: 1,
  alignItems: 'center',
}))`
  margin-top: auto;
`;

export const BannerButtonsWrapperSt = styled(Box).attrs(() => ({
  width: 1 / 2,
}))`
  text-align: center;
`;

export const CancelButtonTextSt = styled(Text).attrs(() => ({
  fontSize: '14px',
  color: color.brandPrimary,
}))`
  text-decoration: underline;
  font-weight: bold;
`;
